
import { useOnScrollTransition } from "@/hooks";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "Heading3",
  props: {
    animation: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const heading = ref([]);

    if (props.animation) useOnScrollTransition(heading, "animate-scroll-fade");

    return { heading };
  },
});
